import { Button, Modal } from 'react-bootstrap';

export interface ConfirmModalProps {
    isOpen: boolean;
    title: string;
    text: string;
    onConfirm: () => void;
    onClose: () => void;
}

export const ConfirmModal = ({
    onClose,
    onConfirm,
    text,
    title,
    isOpen,
}: ConfirmModalProps) => {
    return (
        <Modal show={isOpen} centered size='lg'>
            <Modal.Body>
                <div className='text-center'>
                    <h3>{title}</h3>
                    <p className='fs-5'>{text}</p>
                </div>

                <div className='d-flex justify-content-center gap-2'>
                    <Button variant='primary' onClick={onConfirm}>
                        Si
                    </Button>
                    <Button variant='light' onClick={onClose}>
                        No
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};
